import { type ApplyChangeHandler } from '@atlaskit/editor-plugin-context-panel';
import type { EditorState, PluginKey, Transaction } from '@atlaskit/editor-prosemirror/state';

import { getPluginState } from './plugin-factory';

// TODO: Cleanup once composable editor is completely supported everywhere and we have access to the plugin injection api
// This is for backwards compatiblitity only.
// Please, do not copy or use this kind of code below
// @ts-ignore
const contextPanelPluginKey = {
	key: 'contextPanelPluginKey$',
	getState: (state: EditorState) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return (state as any)['contextPanelPluginKey$'];
	},
} as PluginKey;

export const refreshContextPanel =
	(applyChangeToContextPanel: ApplyChangeHandler | undefined) =>
	(tr: Transaction, state: EditorState): Transaction => {
		const { isProactiveContextPanelOpen } = getPluginState(state);

		if (isProactiveContextPanelOpen) {
			if (applyChangeToContextPanel) {
				return applyChangeToContextPanel(tr);
			} else {
				// FIXME: Once composable editor is completely adopted, we can use the api to instruct the context panel to update.
				// until then we need to keep this meta being set so the context panel will rerender if it's open
				// and we receive more suggestions from BE, that the panel needs to display
				return tr.setMeta(contextPanelPluginKey, { changed: true });
			}
		}
		return tr;
	};
